module.exports = __webpack_public_path__ + "img/5.e32aed83.png";